import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'x-api-key': process.env.REACT_APP_API_KEY,
    'Content-Type': 'application/json'
  }
});

const apiEC2StartStopClient = axios.create({
  baseURL: process.env.REACT_APP_EC2_START_STOP_API_URL,
  headers: {
    'x-api-key': process.env.REACT_APP_API_KEY,
    'Content-Type': 'application/json'
  }
});

export { apiClient, apiEC2StartStopClient };